module.exports = __webpack_public_path__ + "static/media/itsm-software.f78c1726.png";